module.exports = __webpack_public_path__ + "img/m_3.c152f496.png";